//
// Copyright 2022 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/mesh/teleport/notarization.proto (package dxos.mesh.teleport.notarization, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_dxos_keys } from "../../keys_pb.js";
import type { Credential } from "../../halo/credentials_pb.js";
import { file_dxos_halo_credentials } from "../../halo/credentials_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/mesh/teleport/notarization.proto.
 */
export const file_dxos_mesh_teleport_notarization: GenFile = /*@__PURE__*/
  fileDesc("CiVkeG9zL21lc2gvdGVsZXBvcnQvbm90YXJpemF0aW9uLnByb3RvEh9keG9zLm1lc2gudGVsZXBvcnQubm90YXJpemF0aW9uIkkKD05vdGFyaXplUmVxdWVzdBI2CgtjcmVkZW50aWFscxgBIAMoCzIhLmR4b3MuaGFsby5jcmVkZW50aWFscy5DcmVkZW50aWFsMmsKE05vdGFyaXphdGlvblNlcnZpY2USVAoITm90YXJpemUSMC5keG9zLm1lc2gudGVsZXBvcnQubm90YXJpemF0aW9uLk5vdGFyaXplUmVxdWVzdBoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eWIGcHJvdG8z", [file_google_protobuf_empty, file_dxos_keys, file_dxos_halo_credentials]);

/**
 * @generated from message dxos.mesh.teleport.notarization.NotarizeRequest
 */
export type NotarizeRequest = Message<"dxos.mesh.teleport.notarization.NotarizeRequest"> & {
  /**
   * *
   * Write specified credentials to the control feed of the space.
   * Credentials with ids that are already present in the control pipeline must be skipped.
   *
   * @generated from field: repeated dxos.halo.credentials.Credential credentials = 1;
   */
  credentials: Credential[];
};

/**
 * Describes the message dxos.mesh.teleport.notarization.NotarizeRequest.
 * Use `create(NotarizeRequestSchema)` to create a new message.
 */
export const NotarizeRequestSchema: GenMessage<NotarizeRequest> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_teleport_notarization, 0);

/**
 * *
 * Allows peers to request their credentials be written to the control feed.
 * Useful for new devices bootstraping their feeds into the space.
 *
 * @generated from service dxos.mesh.teleport.notarization.NotarizationService
 */
export const NotarizationService: GenService<{
  /**
   * @generated from rpc dxos.mesh.teleport.notarization.NotarizationService.Notarize
   */
  notarize: {
    methodKind: "unary";
    input: typeof NotarizeRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_dxos_mesh_teleport_notarization, 0);

